<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
           <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
            width="250"
          />
        </b-link>

        <!-- Closed Registration Message -->
        <div v-if="!isRegistrationOpen" class="registration-closed-wrapper">
          <div class="registration-closed-card">
            
            <h1 class="closed-title">Informasi Penerimaan Mahasiswa Baru</h1>
            
            <div class="closed-content">
              <p class="main-message">
                <strong>Saat ini, {{ appName }} Universitas Indonesia tidak sedang membuka penerimaan mahasiswa baru.</strong>
              </p>
              
              <p class="sub-message">
                Kami mohon maaf atas ketidaknyamanan ini. Silakan kembali pada periode penerimaan berikutnya.
              </p>
              
              <p class="info-message">
                Informasi lebih lanjut mengenai jadwal dan persyaratan penerimaan akan diumumkan melalui laman resmi <strong>Fakultas Psikologi Universitas Indonesia</strong>.
              </p>
            </div>
            
            <div class="footer-message">
              © 2025 Fakultas Psikologi Universitas Indonesia
            </div>
          </div>
        </div>

        <!-- Login Form - Only show when registration is open -->
        <div v-else>
          <b-card-title>
            Selamat Datang!
          </b-card-title>
          <p>Aplikasi Pendaftaran {{ appName }} Universitas Indonesia </p>

        <!-- form -->
        <validation-observer
          ref="loginForm"
          #default="{invalid}"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent
          >

            <!-- email -->
            <b-form-group
              label-for="email"
              label="Email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="username"
                  name="login-email"
                  :state="errors.length > 0 ? false:null"
                  placeholder="email@example.com"
                  autofocus
                />
               <small class="text-danger">{{ errors[0] ? 'Silahkan isi email anda' : '' }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="password">Kata Sandi</label>
                <b-link :to="{name:'auth-forgot-password'}">
                  <small>Lupa Sandi?</small>
                </b-link>
              </div>
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false:null"
                    name="login-password"
                    placeholder="Password"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
               <small class="text-danger">{{ errors[0] ? 'Silahkan isi password anda' : '' }}</small>
              </validation-provider>
            </b-form-group>

            <!-- checkbox -->
            <b-form-group>
              <b-form-checkbox
                id="remember-me"
                v-model="status"
                name="checkbox-1"
              >
                Ingat Saya
              </b-form-checkbox>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              type="submit"
              block
              :disabled="invalid"
              @click="login()"
            >
              Masuk
            </b-button>
          </b-form>
        </validation-observer>

        <b-card-text class="text-center mt-2">
          <span>Belum Verifikasi Akun? </span>
          <b-link :to="{name:'auth-register'}">
            <span>Verifikasi Sekarang</span>
          </b-link>
        </b-card-text>
        </div>
        <!-- End Login Form -->

      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import {
  BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BCardTitle, BCardText, BInputGroup, BInputGroupAppend, BFormCheckbox, BImg, BSpinner,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import router from '@/router'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  Authlogin,
  setToken,
  setRefreshToken,
} from '@/connection-api/authentication'
import {
  resetAkun,
} from '@/connection-api/master'
import { get } from '@/connection-api/helpers'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BImg,
    vSelect,
    BSpinner,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      appName: process.env.VUE_APP_NAME,
      loading: 0,
      loadingShow: false,
      reset: {},
      username: '',
      password: '',
      status: '',
      required,
      email,
      sideImg: require('@/assets/images/logo/logo.png'),
      isRegistrationOpen: true, // Default to true, will be checked on mount
    }
  },
  mounted() {
    this.checkRegistrationStatus()
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/logo/logo.png')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    checkRegistrationStatus() {
      this.isRegistrationOpen = true
      /*
      get('/setting/status')
        .then(response => {
          // If response status is 200, registration is open
          if (response.status === 200) {
            this.isRegistrationOpen = true
          } else {
            this.isRegistrationOpen = false
          }
        })
        .catch(error => {
          // If request fails (not 200), registration is closed
          console.log('Registration status check failed:', error)
          this.isRegistrationOpen = false
        })
      */
    },
    simpanResetAkun()
    {
      this.loadingShow = true
      resetAkun(this.reset)
      .then(response => {
      if (response.data.success == true) {
        this.loadingShow = false
       this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: `Reset Akun`,
            icon: 'CoffeeIcon',
            variant: 'success',
            text: 'Anda telah berhasil reset akun Ujian Online. Silahkan login menggunakan kredensial baru anda.',
          },
        })
        this.$bvModal.hide('bv-modal-reset-user')
      } else {
        this.loadingShow = false
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: `Reset Akun`,
            icon: 'CoffeeIcon',
            variant: 'success',
            text: response.data.message,
          },
        })
        this.$bvModal.hide('bv-modal-reset-user')
      }
      })
      .catch(error => console.log(error));
    },
    login() {
      this.loading = 1
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          Authlogin({
            email: this.username,
            password: this.password,
            application_token: this.applicationToken,
            token_firebase: localStorage.getItem('tokenFirebase'),
          })
            .then(response => {
              if (response.data.status?.code !== '00') {
                this.loading = 0
                this.$swal({
                  title: 'Gagal!',
                  html: `${response.data.status?.message}`,
                  icon: 'error',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
              } else {
                this.loading = 0
                if(response.data.reset == true)
                {
                  this.$bvModal.show('bv-modal-reset-user')
                  this.reset.token = response.data.token
                }

                const { member, urlCallback } = response.data.data
                setToken(response.data.data.accessToken)
                setRefreshToken(response.data.data.refreshToken)

                localStorage.setItem('userData', JSON.stringify(member))
                this.$ability.update(member.ability)
                if (urlCallback === '') {
                  this.$router.push('/dashboard/users')
                    .then(() => {
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: `Selamat Datang ${member.fullName || member.username}`,
                          icon: 'CoffeeIcon',
                          variant: 'success',
                          text: 'Anda telah berhasil masuk PPDB Online. Sekarang Anda bisa mulai menjelajah!',
                        },
                      })
                    })
                } else {
                  localStorage.setItem('urlCallback', urlCallback)
                  window.location.href = urlCallback
                }
              }
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.auth-wrapper.auth-v1 .auth-inner {
  max-width: 600px;
}
// Registration Closed Styling
.registration-closed-wrapper {
  padding: 2rem 0;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  
  .registration-closed-card {
    text-align: center;
    position: relative;
    overflow: hidden;
    animation: fadeInUp 0.8s ease-out;
    
    &::before {
      content: '';
      position: absolute;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
      animation: pulse 4s ease-in-out infinite;
    }
    
    .icon-wrapper {
      position: relative;
      margin-bottom: 2rem;
      
      .info-icon {
        background: rgba(255, 255, 255, 0.2);
        padding: 1.5rem;
        border-radius: 50%;
        backdrop-filter: blur(10px);
        animation: bounce 2s ease-in-out infinite;
      }
    }
    
    .closed-title {
      font-size: 1.5rem;
      font-weight: 700;
      position: relative;
      
      @media (max-width: 768px) {
        font-size: 1.5rem;
      }
    }
    
    .closed-content {
      padding: 1.5rem;
      border-radius: 15px;
      margin: 2rem 0;
      position: relative;
      
      p {
        margin-bottom: 1.5rem;
        line-height: 1.8;
        font-size: 1.05rem;
        
        &:last-child {
          margin-bottom: 0;
        }
      }
      
      .main-message {
        font-size: 1.2rem;
        color: #e74c3c;
        
        strong {
          font-weight: 700;
        }
      }
      
      .sub-message {
        color: #555;
        font-style: italic;
      }
      
      .info-message {
        color: #34495e;
        padding-top: 1rem;
        border-top: 2px solid #e0e0e0;
        
        strong {
          color: #2c5aa0;
          font-weight: 600;
        }
      }
    }
    
    .footer-message {
      margin-top: 2rem;
      font-size: 0.95rem;
      opacity: 0.9;
      font-weight: 500;
      position: relative;
      letter-spacing: 0.5px;
    }
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: rotate(0deg) scale(1);
    opacity: 0.5;
  }
  50% {
    transform: rotate(180deg) scale(1.1);
    opacity: 0.3;
  }
}

// Dark mode adjustments
.dark-layout {
  .registration-closed-wrapper {
    .registration-closed-card {
      background: linear-gradient(135deg, #1e3a5f 0%, #0f1f35 100%);
      
      .closed-content {
        background: rgba(255, 255, 255, 0.98);
      }
    }
  }
}

// Responsive adjustments
@media (max-width: 992px) {
  .registration-closed-wrapper {
    max-width: 700px;
    
    .registration-closed-card {
      padding: 2.5rem 2rem;
    }
  }
}

@media (max-width: 768px) {
  .registration-closed-wrapper {
    max-width: 100%;
    padding: 1rem;
    
    .registration-closed-card {
      padding: 2rem 1.5rem;
      
      .closed-content {
        padding: 2rem 1.5rem;
      }
    }
  }
}
</style>
